import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center bg-background text-sm text-muted-foreground" data-testid="auth-loading">
        Loading buildnexa.io…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
